import { render, staticRenderFns } from "./StatisticCompareUser.vue?vue&type=template&id=667a80c4"
import script from "./StatisticCompareUser.vue?vue&type=script&lang=js"
export * from "./StatisticCompareUser.vue?vue&type=script&lang=js"
import style0 from "./StatisticCompareUser.vue?vue&type=style&index=0&id=667a80c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports